import { render, staticRenderFns } from "./SettingsSelect.vue?vue&type=template&id=6e280c3a&scoped=true"
import script from "./SettingsSelect.vue?vue&type=script&lang=ts"
export * from "./SettingsSelect.vue?vue&type=script&lang=ts"
import style0 from "./SettingsSelect.vue?vue&type=style&index=0&id=6e280c3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e280c3a",
  null
  
)

export default component.exports